// 新增信息
<template>
    <div class="group">
        <el-row>
            <el-col :span="24">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <i class="el-icon-edit"></i>
                        <span>请输入钻石的详细参数</span>
                    </div>
                    <div class="search-content mar_b">
                        <el-form :inline="true" label-width="120px" size="mini" :model="addDataForm" class="demo-form-inline" ref="addDataForm" :rules="rules">
                            <!--<el-form-item prop="stock_id" label="货号：">
                                <el-input style="width:180px;" v-model="addDataForm.stock_id" placeholder="请输入"></el-input>
                            </el-form-item>-->
                            
                            <!--
                            <el-form-item prop="supplier_rapid" label="供应商rapid：">
                                <el-input style="width:180px;" v-model="addDataForm.supplier_rapid" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="supplier" label="供应商：">
                                <el-input style="width:180px;" v-model="addDataForm.supplier" placeholder="请输入"></el-input>
                            </el-form-item><br>
                            -->
                            <el-form-item prop="shape" label="形状：">
                                <el-select v-model="addDataForm.shape" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in shapeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="ct" label="重量：">
                                <el-input style="width:180px;" v-model="addDataForm.ct" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="col" label="颜色：">
                                <el-select v-model="addDataForm.col" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in colList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="cla" label="净度：">
                                <el-select v-model="addDataForm.cla" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in claList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item><br>
                            
                            <el-form-item prop="cut" label="切工：">
                                <el-select v-model="addDataForm.cut" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in cutList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="pol" label="抛光：">
                                <el-select v-model="addDataForm.pol" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in polList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="sym" label="对称：">
                                <el-select v-model="addDataForm.sym" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in polList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="fl" label="荧光：">
                                <el-select v-model="addDataForm.fl" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in flList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item><br>

                            <el-form-item prop="new_dis" label="销售折扣：">
                                <el-input style="width:180px;" v-model="addDataForm.new_dis" placeholder="请输入折扣；eg：-45.22"></el-input>
                            </el-form-item>
                            <el-form-item prop="sale_rap" label="销售rap：">
                                <el-input style="width:180px;" v-model="addDataForm.sale_rap" placeholder="请输入数值；eg：2200"></el-input>
                            </el-form-item>
                            <el-form-item prop="cert" label="证书：">
                                <el-select v-model="addDataForm.cert" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in certList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="cert_no" label="证书号：">
                                <el-input style="width:180px;" v-model="addDataForm.cert_no" placeholder="请输入"></el-input>
                                <el-button type="primary" @click="selectList">查询</el-button>
                            </el-form-item>
                            <br><br>
                            <el-form-item prop="year" label="年份：">
                                <el-input style="width:180px;" v-model="addDataForm.year" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="place" label="地点：">
                                <el-select v-model="addDataForm.place" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in placeList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="inv_status" label="库存状态：">
                                <el-select v-model="addDataForm.inv_status" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in inv_statusList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item prop="sale_status" label="销售状态：">
                                <el-select v-model="addDataForm.sale_status" placeholder="请选择" style="width:180px">
                                    <el-option v-for="item in sale_statusList" :key="item.value" :label="item.value" :value="item.value"></el-option>
                                </el-select>
                            </el-form-item><br>
                            <!--
                            <el-form-item prop="buy_date" label="采购日期：">
                                <el-date-picker style="width:180px;" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" v-model="addDataForm.buy_date"></el-date-picker>
                            </el-form-item>
                            
                            <el-form-item prop="cost_rap" label="成本rap：">
                                <el-input style="width:180px;" v-model="addDataForm.cost_rap" placeholder="请输入数值；eg：2200"></el-input>
                            </el-form-item><br>

                            <el-form-item prop="cost_dis" label="成本折扣：">
                                <el-input style="width:180px;" v-model="addDataForm.cost_dis" placeholder="请输入折扣；eg：-48.52"></el-input>
                            </el-form-item>
                            <el-form-item prop="cost" label="货品成本：">
                                <el-input style="width:180px;" v-model="addDataForm.cost" placeholder="请输入成本；eg：256.6"></el-input>
                            </el-form-item>
                            <el-form-item prop="point" label="综合费点：">
                                <el-input style="width:180px;" v-model="addDataForm.point" placeholder="请输入费点；eg：1.047"></el-input>
                            </el-form-item>
                            <el-form-item prop="usd_cost" label="美金成本：">
                                <el-input style="width:180px;" v-model="addDataForm.usd_cost" placeholder="请输入成本；eg：544.66"></el-input>
                            </el-form-item><br>

                            <el-form-item prop="rmb_cost" label="人民币成本：">
                                <el-input style="width:180px;" v-model="addDataForm.rmb_cost" placeholder="请输入成本；eg：544.66"></el-input>
                            </el-form-item>
                            -->
                            <el-form-item prop="meas" label="尺寸：">
                                <el-input style="width:180px;" v-model="addDataForm.meas" placeholder="请输入尺寸；eg：4.33*4.29-2.68"></el-input>
                            </el-form-item>
                            <el-form-item prop="table1" label="台面：">
                                <el-input style="width:180px;" v-model="addDataForm.table1" placeholder="请输入台面；eg：58"></el-input>
                            </el-form-item>
                            <el-form-item prop="depth" label="全深：">
                                <el-input style="width:180px;" v-model="addDataForm.depth" placeholder="请输入全深；eg：61.22"></el-input>
                            </el-form-item>
                            <el-form-item prop="ratio" label="比例：">
                                <el-input style="width:180px;" v-model="addDataForm.ratio" placeholder="请输入比例；eg：1.02"></el-input>
                            </el-form-item><br>

                            <el-form-item prop="cla_level" label="净度等级：">
                                <el-input style="width:180px;" v-model="addDataForm.cla_level" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="rating" label="评价：">
                                <el-input style="width:180px;" v-model="addDataForm.rating" placeholder="请输入"></el-input>
                            </el-form-item>
                            <!--
                            <el-form-item prop="bt" label="BT：">
                                <el-input style="width:180px;" v-model="addDataForm.bt" placeholder="请输入"></el-input>
                            </el-form-item>
                            <el-form-item prop="bs" label="BS：">
                                <el-input style="width:180px;" v-model="addDataForm.bs" placeholder="请输入"></el-input>
                            </el-form-item>
                            -->
                            <br>
                            <el-form-item prop="remark" label="备注：">
                                <el-input type="textarea" :autosize="{minRows:6, maxRows:3}" style="width:500px;"
                                    placeholder="请输入内容" v-model="addDataForm.remark">
                                </el-input>
                            </el-form-item><br>
                            <el-form-item class="search-but">
                                <!--<el-button type="primary" @click="dialogTableVisible10 = false">取 消</el-button>-->
                                <el-button type="primary" @click="onSubmit">保存并提交</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import util from '../../common/js/util';
    export default {
        data() {
            return {
                // 查询
                query: {
                    khmc: '',
                    khbh: '',
                    ssjg: '',
                    hy: '',
                    yjdj: '',
                    clzt: '',
                    ssrdkq: '',
                    yjsj: [],
                    dkye: ''
                },
                shapeList1: [{'value':'round'},{'value':'princess'},{'value':'radiant'}
                            ,{'value':'asscher'},{'value':'marquise'},{'value':'oval'}
                            ,{'value':'emerald'},{'value':'pear'},{'value':'heart'}
                            ,{'value':'cushion'},{'value':'others'},{'value':'triangle'}],
                shapeList: [{'value':'圆形'},{'value':'公主方'},{'value':'雷迪恩'}
                            ,{'value':'阿斯切'},{'value':'马眼'},{'value':'椭圆形'}
                            ,{'value':'祖母绿'},{'value':'梨形'},{'value':'心形'}
                            ,{'value':'垫形'},{'value':'其他'},{'value':'三角形'}],
                colList: [{'value':'D'},{'value':'E'},{'value':'F'}
                            ,{'value':'G'},{'value':'H'},{'value':'I'}
                            ,{'value':'J'},{'value':'K'},{'value':'L'}
                            ,{'value':'M-N'},{'value':'O-Z'}],
                claList: [{'value':'FL'},{'value':'IF'},{'value':'VVS1'}
                            ,{'value':'VVS2'},{'value':'VS1'},{'value':'VS2'}
                            ,{'value':'SI1'},{'value':'SI2'},{'value':'SI3'}
                            ,{'value':'I1'},{'value':'I2'}],
                cutList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'},{'value':'NN'}],
                polList: [{'value':'EX'},{'value':'VG'},{'value':'GD'}
                            ,{'value':'FR'},{'value':'PR'}],
                flList: [{'value':'N'},{'value':'VSL'},{'value':'F'}
                            ,{'value':'M'},{'value':'S'},{'value':'VS'}],
                placeList: [{'place':'全部'},{'place':'HK'},{'place':'CHINA'},{'place':'SZ'}
                            ,{'place':'INDIA'},{'place':'LAB'},{'place':'SH'},{'place':'H-K'}],
                certList: [{'value':'GIA'},{'value':'NGTC'},{'value':'IGI'}
                            ,{'value':'HRD'},{'value':'None'},{'value':'Other'}],
                inv_statusList: [{'value':'在库'},{'value':'不在库'}],
                sale_statusList: [{'value':'在售'},{'value':'已完成'}],
                addDataForm:{
                    inv_status: '在库',
                    sale_status: '在售'
                },
                rules:{
                    shape:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    ct:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    col:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    cla:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    cut:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    pol:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    sym:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    fl:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    cert:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    cert_no:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    sale_rap:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ],
                    new_dis:[
                        {
                            required:true,
                            message:'请输入内容',
                            trigger:'blur'
                        }
                    ]
                }
            };
        },
        methods: {
            onSubmit() {
                let _this = this;
                // 判断表单是否通过了表单验证
                this.$refs.addDataForm.validate((valid) => {
                    if (valid) { // 通过了则将数据返回后台
                        util.publicget('/diamond/savaDaimondInfo', {
                            // user: document.cookie.split(';')[1].split('=')[1],
                            user: sessionStorage.getItem('userName'),
                            // stock_id: _this.addDataForm.stock_id,
                            place: _this.addDataForm.place,
                            supplier_rapid: _this.addDataForm.supplier_rapid,
                            supplier: _this.addDataForm.supplier,

                            shape: _this.addDataForm.shape,
                            ct: _this.addDataForm.ct,
                            col: _this.addDataForm.col,
                            cla: _this.addDataForm.cla,
                            cut: _this.addDataForm.cut,
                            pol: _this.addDataForm.pol,
                            sym: _this.addDataForm.sym,
                            fl: _this.addDataForm.fl,
                            
                            inv_status: _this.addDataForm.inv_status,
                            sale_status: _this.addDataForm.sale_status,
                            buy_date: _this.addDataForm.buy_date,
                            cost_rap: _this.addDataForm.cost_rap,
                            cost_dis: _this.addDataForm.cost_dis,
                            
                            new_dis: _this.addDataForm.new_dis,
                            sale_rap: _this.addDataForm.sale_rap,
                            cost: _this.addDataForm.cost,
                            point: _this.addDataForm.point,
                            usd_cost: _this.addDataForm.usd_cost,
                            rmb_cost: _this.addDataForm.rmb_cost,
                            meas: _this.addDataForm.meas,

                            table1: _this.addDataForm.table1 ,
                            depth: _this.addDataForm.depth,
                            ratio: _this.addDataForm.ratio,
                            cla_level: _this.addDataForm.cla_level,
                            remark: _this.addDataForm.remark,

                            ec: _this.addDataForm.ec,
                            bt: _this.addDataForm.bt,
                            bs: _this.addDataForm.bs,
                            year: _this.addDataForm.year,
                            
                            cert: _this.addDataForm.cert,
                            cert_no: _this.addDataForm.cert_no
                        }, function (res) {
                            if (res.flag) {
                                _this.successMsg('本次操作成功！');
                            } else {
                                _this.errorMsg(res.msg);
                            }
                        });
                    } else { // 否则返回
                        return false;
                    }
                });
            },
            // 加载查询单条记录
            selectList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondList', {
                    equalsCert_no: _this.addDataForm.cert_no
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        if(res.obj.length>0) {
                            _this.addDataForm = res.obj[0];
                            _this.successMsg('查询成功！');
                        }else {
                            _this.showMsg("该证书号数据不存在");
                        }
                    } else {
                        _this.errorMsg(res.msg);
                    }
                });
            },
            // 查询数据字典 地点
            selectPlaceDictList() {
                let _this = this;
                util.publicget('/diamond/queryDaimondDictList', {
                    equalsParam: '地点'
                }, function (res) {
                    if (res.flag) {
                        // console.log(res.obj);
                        _this.placeList = res.obj;
                    } else {
                        _this.errorMsg("操作异常！");
                    }
                });
            },
            // 时间格式化
            formatterDate(row, column) {
                return util.formatDate.format(new Date(row.yjsj), 'yyyy-MM-dd hh:mm:ss');
            },
            // 取消
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            getControlTimeTo(val) {
                let date = new Date(val);
                let sipt = '-';
                let siptTo = ':';
                let month = date.getMonth() + 1;
                let day = date.getDate();
                let hours = date.getHours();
                let minutes = date.getMinutes();
                let seconds = date.getSeconds();
                let milliseconds = date.getMilliseconds();
                if (month >= 1 && month <= 9) {
                    month = '0' + month;
                }
                if (day >= 1 && day <= 9) {
                    day = '0' + day;
                }
                if (hours >= 0 && hours <= 9) {
                    hours = '0' + hours;
                }
                if (minutes >= 0 && minutes <= 9) {
                    minutes = '0' + minutes;
                }
                if (seconds >= 0 && seconds <= 9) {
                    seconds = '0' + seconds;
                }
                if (milliseconds >= 0 && milliseconds <= 9) {
                    milliseconds = '00' + milliseconds;
                }
                if (milliseconds >= 10 && milliseconds <= 99) {
                    milliseconds = '0' + milliseconds;
                }
                let currentdate = date.getFullYear() + sipt + month + sipt + day + 'T' + hours + siptTo + minutes + siptTo + seconds + '.' + milliseconds + 'Z';
                return currentdate;
            },
            // 时间确定按钮
            onChangeDate(val) {
                if (val) {
                    let that = this;
                    that.query.yjsj = [this.getControlTimeTo(val[0]), this.getControlTimeTo(val[1])];
                }
            }
        },
        mounted() {
            this.selectPlaceDictList();
        }
    };
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/diamond/diamondInsert.vue